/* EVENTS */
export const EARNING_STEP_1_EVENT = 'earning_simulation_step_1'
export const EARNING_STEP_2_EVENT = 'earning_simulation_step_2'
export const EARNING_STEP_3_EVENT = 'earning_simulation_step_3'
export const EARNING_END = 'earning_simulation_end'
